export function utmParams(url) {
  if (typeof window === 'undefined') {
    return null;
  }

  const params = new URL(url || document.location).searchParams;
  if (
    params.get('utm_source') &&
    params.get('utm_medium') &&
    params.get('utm_campaign')
  ) {
    return {
      term: params.get('utm_term'),
      source: params.get('utm_source'),
      medium: params.get('utm_medium'),
      content: params.get('utm_content'),
      campaign: params.get('utm_campaign'),
    };
  }

  return null;
}
